import config from '@/config/prod.env';
import header from '@/helper/header';
import common from '@/helper/common';

const mainUrl = `${process.env.VUE_APP_API_URL}/PowerBI`;

export default { 
    getAccessToken: async (appAccessToken) => {
        const requestOptions = {
            method: 'POST',
            headers: { 
                'Content-Type': 'application/json', 
                'Authorization': 'Bearer ' + appAccessToken
            }
        };
    
        let rs = await fetch(`${mainUrl}/GetAccessToken`, requestOptions);
        return await common.handleResponse(rs);
    },

    getReports: async (workspaceId) => {
        let user = JSON.parse(localStorage.getItem('login_info'));
        const requestOptions = {
            method: 'POST',
            headers: await header.authHeaderWithToken(),
            body: JSON.stringify({ 
                "azureToken": user.pbiAccessToken.access_token,
                "workspaceId": workspaceId
            })
        };
    
        let rs = await fetch(`${mainUrl}/GetReports`, requestOptions);
        return await common.handleResponse(rs);
    },
    
    getDatasets: async (workspaceId) => {
        let user = JSON.parse(localStorage.getItem('login_info'));
        const requestOptions = {
            method: 'POST',
            headers: await header.authHeaderWithToken(),
            body: JSON.stringify({ 
                "azureToken": user.pbiAccessToken.access_token,
                "workspaceId": workspaceId
            })
        };
    
        let rs = await fetch(`${mainUrl}/GetDatasets`, requestOptions);
        return await common.handleResponse(rs);
    },

    refreshDataset: async (datasetId) => {
        let user = JSON.parse(localStorage.getItem('login_info'));
        const requestOptions = {
            method: 'POST',
            headers: await header.authHeaderWithToken(),
            body: JSON.stringify({ 
                "azureToken": user.pbiAccessToken.access_token,
                "datasetId": datasetId
            })
        };
    
        let rs = await fetch(`${mainUrl}/RefreshDataset`, requestOptions);
        return await common.handleResponse(rs);
    },

    getRefreshSchedule: async (datasetId) => {
        let user = JSON.parse(localStorage.getItem('login_info'));
        const requestOptions = {
            method: 'POST',
            headers: await header.authHeaderWithToken(),
            body: JSON.stringify({ 
                "azureToken": user.pbiAccessToken.access_token,
                "datasetId": datasetId
            })
        };
    
        let rs = await fetch(`${mainUrl}/GetRefreshSchedule`, requestOptions);
        return await common.handleResponse(rs);
    },

    getRefreshHistory: async (datasetId) => {
        let user = JSON.parse(localStorage.getItem('login_info'));
        const requestOptions = {
            method: 'POST',
            headers: await header.authHeaderWithToken(),
            body: JSON.stringify({ 
                "azureToken": user.pbiAccessToken.access_token,
                "datasetId": datasetId,
            })
        };
    
        let rs = await fetch(`${mainUrl}/GetRefreshHistory`, requestOptions);
        return await common.handleResponse(rs);
    },

    updateRefreshSchedule: async (datasetId, times, enabled) => {
        let user = JSON.parse(localStorage.getItem('login_info'));
        const requestOptions = {
            method: 'POST',
            headers: await header.authHeaderWithToken(),
            body: JSON.stringify({ 
                "azureToken": user.pbiAccessToken.access_token,
                "datasetId": datasetId,
                "value": {
                    //"days": days,
                    "times": times,
                    //"localTimeZoneId": "UTC"
                    "enabled": enabled
                }
            })
        };
    
        let rs = await fetch(`${mainUrl}/UpdateRefreshSchedule`, requestOptions);
        return await common.handleResponse(rs);
    },
}